<template>
  <div class="page content">
    <!-- 碎片区域 -->
    <div 
      class="pieces-box"
      @click="getCoordinate"
    >
      <div 
        class="pieces" 
        v-for="(item, index) in activePieces.pieces"
        :key="index" 
        :style="{'background-color': item.color, 'clip-path': `polygon(${item.point1.x}px ${item.point1.y}px, ${item.point2.x}px ${item.point2.y}px, ${item.point3.x}px ${item.point3.y}px)`, 'transition-delay': `${index / 45}s, ${index / 30}s`}"
      />
    </div>
    
    <!-- 切换按钮 -->
    <div class="page-btn">
      <div
        class="prev-page" 
        @click.stop="prevPage"
      />
      <div
        class="next-page"
        @click.stop="nextPage"
      />
    </div>
  </div>
</template>

<script>
import piecesData from '../piecesData.js'

export default {
  name: 'Test',
  data: function ()  {
    return {
      piecesData,

      // 是否在滑动
      // isTouching: false,

      // 碎片区域的尺寸
      wrapperSize: 0,

      // 图形
      // pieces: [],
      piecesIndex: piecesData.length - 1,

      // 是否打开人大条
      openBox: false
    }
  },
  computed: {
    activePieces () {
      const data = this.piecesData[this.piecesIndex]
      // console.log(this.piecesIndex, data)

      return data
    }
  },
  components: {
    // HelloWorld
  },
  mounted () {
    console.log('content mounted')
    this.wrapperSize = document.querySelector('.pieces-box').clientHeight
  },

  methods: {
    test () {
      console.log(1)
    },
    
    // 获取点位坐标
    getCoordinate  (event)  {
      console.log(`${event.layerX * 2},${event.layerY * 2}`)
    },

    // 滑动中
    touchMove (event) {
      if (!this.isTouching) {
        this.isTouching = true
        this.touchStart = {
          x: event.touches[0].pageX, 
          y: event.touches[0].pageY
        }
      } else {
        this.touchEnding = {
          x: event.touches[0].pageX, 
          y: event.touches[0].pageY
        }
      }
      // console.log('touch move', event.touches[0].pageX, event.touches[0].pageY)
      console.log('touch move')
    },
    
    // 滑动结束
    touchEnd () {
      if (!this.touchStart || !this.touchEnding) {
        return false
      }
      const touchResult = (this.touchEnding.x - this.touchStart.x) / Math.abs((this.touchEnding.y - this.touchStart.y))
      console.log('touch end', touchResult)


      if (touchResult > 5) {
        // 向右滑动
        this.prevPage()
      } else if (touchResult < -5) {
        // 向左滑动
        this.nextPage()
      }
      this.isTouching = false
      this.touchStart = ''
      this.touchEnding = ''
    },


    prevPage () {
      if (this.piecesIndex > 0) {
        this.piecesIndex --
      } else {
        console.log('没有前一页了')
      }
    },

    nextPage () {
      if (this.piecesIndex < this.piecesData.length - 1) {
        this.piecesIndex ++
      } else {
        console.log('没有后一页了')
      }
    },

    // 调用piece的动画
    pieceAnimate () {

    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  background-color: #E6A23C;

  /* 三角图形区域 */
  .pieces-box {
    position: absolute;
    top: 0;
    left: 4rem;
    z-index: 2;

    width: 1080px;
    height: 1080px;
    border: solid 1px #000;
    .pieces {
      position: absolute;
      top: 0;
      left: 0;
      width: 1080px;
      height: 1080px;
      
      // transform-origin: 0 0;
      // -moz-transform-origin: 0 0;
      // transform: scale(0.33, 0.33);
      // -webkit-transform: scale(0.33, 0.33);

      transition: background-color .5s ease-out, clip-path .5s ease-out;
      -webkit-transition: background-color .5s ease-out, clip-path .5s ease-out;
    }
  }
  .pieces-animating {
    .pieces {
      transition-delay: 0;
    }
  }
  

  // 滑动切换页面事件
  .touch-handler {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 4;
    width: 100%;
    height: 100%;
  }

  // 翻页的按钮
  .page-btn {
    .prev-page, .next-page {
      position: absolute;
      top: 0;
      z-index: 5;
      width: 3rem;
      height: 100%;
      background-color: #F56C6C;
      opacity: .5;
    }
    .prev-page {
      left: 0;
    }
    .next-page {
      right: 0;
    }
  }

  // 十四五摘条文字
  ._145 {
    position: absolute;
    // bottom: 4rem;
    bottom: 25%;
    z-index: 3;

    margin: 0 1.52rem;
    width: 16.96rem;
    height: 9.36rem;
    .title {
      position: absolute;
      top: 0;
      line-height: 1;
      font-weight: bold;
      font-size: 1.52rem;
      color: #ffffff;
    }
    .text {
      position: absolute;
      top: 2.24rem;
      text-align: left;
      line-height: 1.7;
      font-size: .72rem;
    }
  }

  /* 底部人大浮动条 */
  .renda-box {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 9;

    width: 100%;
    height: 4rem;
    overflow: hidden;
    background-color: #ffffff;
    text-align: left;

    .shadow {
      position: absolute;
      bottom: 4rem;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, .5);
      opacity: 0;
      transition: opacity 1s ease;
      -webkit-transition: opacity 1s ease;
    }
    .shadow-show {
      opacity: 1;
    }

    .renda {
      position: relative;
      margin: .7rem 1.44rem;
      height: 3.2rem;
      background-color: #ffffff;

      .head {
        position: absolute;
        top: 0;
        left: 0;
        border-radius: .32rem;
        width: 1.44rem;
        height: 1.44rem;
        background-color: #E6A23C;
      }

      .title {
        position: absolute;
        top: 0.1rem;
        left: 1.92rem;
        line-height: 1;
        font-size: .53rem;
        color: #666666;
      }

      .desc {
        position: absolute;
        top: 1.01rem;
        left: 1.92rem;
        width: 13.1rem;
        line-height: 1.33;
        font-size: .7rem;
        color: #333333;
      }

      .btn {
        position: absolute;
        top: 0;
        right: -.5rem;
        padding: .3rem .5rem;
        width: .5rem;
        height: 1rem;
        background-color: #E6A23C;
      }

      .player {
        position: absolute;
        top: 0;
        right: 2rem;
        border-radius: .5rem;
        width: 3rem;
        height: 1rem;
        background-color: #E6A23C;
        text-align: center;
        line-height: 1rem;
        font-size: .4rem;

        opacity: 0;
        transition: opacity 1s ease;
        -webkit-transition: opacity 1s ease;
      }
    }
  }
  // 打开状态
  .renda-box-open {
    overflow: initial;
    .renda {
      .player {
        opacity: 1;
      }
    }
  }
}
</style>
